export class GitTreeEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "TreeEntryType",
            "format": ""
        },
        {
            "name": "sha",
            "baseName": "sha",
            "type": "string",
            "format": ""
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitTreeEntry.attributeTypeMap;
    }
    constructor() {
    }
}
